module.exports = __webpack_public_path__ + "static/media/yandex_order.92cf438b.svg";